/**
 * @desc 拆箱
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.StockSplitBoxDto>, options?: any) {
  return updateResponse(
    http(URL + `/stockPool/splitBox`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
